import { isStudioLandingPagesPath } from '../lib/mfe-paths'
import type { MatchPathFn } from '@repo/studio-config/studio-config-context'

export const nextMatchPath: MatchPathFn = ({ path, end }, pathname) => {
  const escaped = path
    .replace(/[.+?^${}()|[\]\\]/g, '\\$&')
    .replace(/:[^/]+/g, '[^/]+')
    .replace(/\*/g, '.*')
  return new RegExp(end ? `^${escaped}$` : `^${escaped}(/|$)`).test(pathname)
}

/**
 * In-MFE paths stay exact so locale URL sync can drop `/fr` when switching to
 * English. Document loads into Vite Studio go through `toDocumentHref`, which
 * applies the same as-needed prefix as chrome `<a>`s.
 */
export function applyStudioLandingPagesNavigate(
  path: string,
  options: { replace?: boolean } | undefined,
  host: {
    assignDocument: (path: string) => void
    replaceDocument: (path: string) => void
    push: (path: string) => void
    replace: (path: string) => void
    toDocumentHref: (path: string) => string
  },
) {
  if (!isStudioLandingPagesPath(path)) {
    const href = host.toDocumentHref(path)
    if (options?.replace) {
      host.replaceDocument(href)
      return
    }
    host.assignDocument(href)
    return
  }

  if (options?.replace) {
    host.replace(path)
    return
  }

  host.push(path)
}
